import { isMobileDevice } from '@repo-level/core-front';
import androidStep2Src from 'assets/images/mobileApp/android/step2.webp';
import androidStep3Src from 'assets/images/mobileApp/android/step3.webp';
import androidStep4Src from 'assets/images/mobileApp/android/step4.webp';
import androidStep5Src from 'assets/images/mobileApp/android/step5.webp';
import androidStep6Src from 'assets/images/mobileApp/android/step6.webp';
import pwaForAndroidStep2Src from 'assets/images/mobileApp/pwaForAndroid/step2.webp';
import pwaForAndroidStep3Src from 'assets/images/mobileApp/pwaForAndroid/step3.webp';
import pwaForAndroidStep4Src from 'assets/images/mobileApp/pwaForAndroid/step4.webp';
import pwa4Step2Src from 'assets/images/mobileApp/pwaForIOSChrome/step2.webp';
import pwa4Step3Src from 'assets/images/mobileApp/pwaForIOSChrome/step3.webp';
import pwa4Step4Src from 'assets/images/mobileApp/pwaForIOSChrome/step4.webp';
import pwa1Step2Src from 'assets/images/mobileApp/pwaForIOSSafari/step2.webp';
import pwa1Step3Src from 'assets/images/mobileApp/pwaForIOSSafari/step3.webp';
import pwa1Step4Src from 'assets/images/mobileApp/pwaForIOSSafari/step4.webp';
import pwa3Step1Src from 'assets/images/mobileApp/pwaForMac/step1.webp';
import pwa3Step2Src from 'assets/images/mobileApp/pwaForMac/step2.webp';
import pwa3Step3Src from 'assets/images/mobileApp/pwaForMac/step3.webp';
import pwa2Step1Src from 'assets/images/mobileApp/pwaForWindows/step1.webp';
import pwa2Step2Src from 'assets/images/mobileApp/pwaForWindows/step2.webp';
import pwa2Step3Src from 'assets/images/mobileApp/pwaForWindows/step3.webp';
import { Button } from 'components/buttons';
import { DownloadAndroidApp } from 'components/DownloadAndroidApp';
import type { TFunction } from 'i18next';

export const MOBILE_APP_PAGE_URL = '/mobile-app';

export const getAndroidSteps = (t: TFunction, apkUrl: string) => [
  ...[
    isMobileDevice
      ? {
          description: t('androidApp.step1Mobile'),
          component: <DownloadAndroidApp download />,
        }
      : {
          description: t('androidApp.step1'),
          qrSrc: apkUrl,
        },
  ],
  {
    description: t('androidApp.step2'),
    img: {
      src: androidStep2Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
  {
    description: t('androidApp.step3'),
    img: {
      src: androidStep3Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
  {
    description: t('androidApp.step4'),
    img: {
      src: androidStep4Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
  {
    description: t('androidApp.step5'),
    img: {
      src: androidStep5Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
  {
    description: t('androidApp.step6'),
    img: {
      src: androidStep6Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
];

export const getPWAForIOSSafariSteps = (t: TFunction) => [
  ...(isMobileDevice
    ? []
    : [
        {
          description: t('pwaForIOSSafari.step1'),
          qrSrc: `${window.location.origin}${MOBILE_APP_PAGE_URL}`,
        },
      ]),
  {
    description: t('pwaForIOSSafari.step2'),
    img: {
      src: pwa1Step2Src,
      width: 168,
      height: 324,
    },
  },
  {
    description: t('pwaForIOSSafari.step3'),
    img: {
      src: pwa1Step3Src,
      width: 168,
      height: 324,
    },
  },
  {
    description: t('pwaForIOSSafari.step4'),
    img: {
      src: pwa1Step4Src,
      width: 168,
      height: 324,
    },
  },
];

export const getPWAForIOSChromeSteps = (t: TFunction) => [
  ...(isMobileDevice
    ? []
    : [
        {
          description: t('pwaForIOSChrome.step1'),
          qrSrc: `${window.location.origin}${MOBILE_APP_PAGE_URL}`,
        },
      ]),
  {
    description: t('pwaForIOSChrome.step2'),
    img: {
      src: pwa4Step2Src,
      width: 168,
      height: 324,
    },
  },
  {
    description: t('pwaForIOSChrome.step3'),
    img: {
      src: pwa4Step3Src,
      width: 168,
      height: 324,
    },
  },
  {
    description: t('pwaForIOSChrome.step4'),
    img: {
      src: pwa4Step4Src,
      width: 168,
      height: 324,
    },
  },
];

export const getPWAForWindowsSteps = (t: TFunction) => [
  {
    description: t('pwaForWindows.step1'),
    img: {
      src: pwa2Step1Src,
      width: 136,
      height: 60,
    },
  },
  {
    description: t('pwaForWindows.step2'),
    img: {
      src: pwa2Step2Src,
      width: 226,
      height: 46,
    },
  },
  {
    description: t('pwaForWindows.step3'),
    img: {
      src: pwa2Step3Src,
      width: 288,
      height: 108,
    },
  },
];

export const getPWAForMacSteps = (t: TFunction) => [
  {
    description: t('pwaForMac.step1'),
    img: {
      src: pwa3Step1Src,
      width: 136,
      height: 60,
    },
  },
  {
    description: t('pwaForMac.step2'),
    img: {
      src: pwa3Step2Src,
      width: 226,
      height: 46,
    },
  },
  {
    description: t('pwaForMac.step3'),
    img: {
      src: pwa3Step3Src,
      width: 288,
      height: 108,
    },
  },
];

export const getPWAForAndroidSteps = (t: TFunction) => [
  ...[
    isMobileDevice
      ? {
          description: t('pwaForAndroid.step1Mobile'),
          component: (
            <Button
              green
              onClick={() => {
                const btn = document.getElementById('installPWAButton');
                if (btn) btn.click();
              }}
              xLarge
            >
              {t('pwaForAndroid.button')}
            </Button>
          ),
        }
      : {
          description: t('pwaForAndroid.step1'),
          qrSrc: `${window.location.origin}${MOBILE_APP_PAGE_URL}`,
        },
  ],
  ...(isMobileDevice
    ? []
    : [
        {
          description: t('pwaForAndroid.step2'),
          img: {
            src: pwaForAndroidStep2Src,
            width: isMobileDevice ? 143 : 124,
            height: isMobileDevice ? 300 : 260,
          },
        },
      ]),
  {
    description: t('pwaForAndroid.step3'),
    img: {
      src: pwaForAndroidStep3Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
  {
    description: t('pwaForAndroid.step4'),
    img: {
      src: pwaForAndroidStep4Src,
      width: isMobileDevice ? 143 : 124,
      height: isMobileDevice ? 300 : 260,
    },
  },
];
